function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Sync",
  d: "M19,12v1.5a4,4,0,0,1,3.33,6.21l-1.09-1.09A2.51,2.51,0,0,0,19,15v1.5l-2.25-2.25L19,12m0,11V21.5a4,4,0,0,1-3.33-6.21l1.09,1.09A2.51,2.51,0,0,0,19,20V18.5l2.25,2.25L19,23M12,3c4.42,0,8,1.79,8,4s-3.58,4-8,4S4,9.21,4,7s3.58-4,8-4M4,9c0,2.21,3.58,4,8,4a14.91,14.91,0,0,0,3.14-.32,6.53,6.53,0,0,0-2,3.28L12,16c-4.42,0-8-1.79-8-4V9M20,9v2h-.5l-.6,0A2.72,2.72,0,0,0,20,9M4,14c0,2.21,3.58,4,8,4l1,0A6.68,6.68,0,0,0,14,20.88L12,21c-4.42,0-8-1.79-8-4Z",
  transform: "translate(-4 -3)"
});

var SvgIndexSync = function SvgIndexSync(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IndexSync",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndexSync, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IndexSync.b61b6b39.svg";
export { ForwardRef as ReactComponent };